import { StyledLayout } from "../../styled/layout";
import { StyledSectionHeading } from "../../styled/commons";

/**
 * Encabezado de sección reutilizable: tag + título + bajada.
 * `title` acepta nodos para poder resaltar partes con <GradientText>.
 */
const SectionHeading = ({ tag, title, lead, center = false }) => (
  <StyledSectionHeading.Root center={center}>
    {tag && <StyledLayout.Tag>{tag}</StyledLayout.Tag>}
    {title && <StyledLayout.Title>{title}</StyledLayout.Title>}
    {lead && <StyledLayout.Lead>{lead}</StyledLayout.Lead>}
  </StyledSectionHeading.Root>
);

export default SectionHeading;
